import {APIDirectory , HTTP} from '../../rest'
import { constant } from "./SystemConfigActionsConstants";
import { getKeyFromLS, setDataInLS } from '../../utils/LocalStorageUtil'
export const getSystemConfigInProgress = () => {
    return{
    type:constant.GET_SYSTEM_CONFIG_IN_PROGRESS
}}

export const getSystemConfigComplete =(data) => {
    return{
        type:constant.GET_SYSTEM_CONFIG_COMPLETE,
        data:data
    }
}

export const getSystemConfig = ()=>
{
    return async dispatch => {
        try{
            dispatch(getSystemConfigInProgress());
            let url = APIDirectory.getSystemConfigURL();
            let systemConfig = await HTTP.GET(url);
            if(true){
                setDataInLS("systemConfig", systemConfig);
            }
            dispatch(getSystemConfigComplete(systemConfig));
            return systemConfig;
        }
        catch(error){
            return[];
        }

    }
}





